export const STORE_TRANSLATION_KEYS = {
  BUY: 'store_buy',
  BUY_FOR: 'store_buy_for',
  CONNECTION_ERROR: 'connection_error',
  ERROR_SUBTITLE: 'store_error_subtitle',
  ERROR_TITLE: 'store_error_title',
  NOT_ENOUGH_COINS: 'store_not_enough_coins',
  RELATED_GAMES: 'smartico_tournaments_related_games',
  RELATED_ITEMS: 'store_related_items',
  STORE_EMPTY_GO_TO_CASINO: 'go_to_casino',
  STORE_EMPTY_SUBTITLE: 'store_empty_subtitle',
  STORE_EMPTY_TITLE: 'store_empty_title',
  STORE_PAGE_TITLE: 'store_page_title',
  TERMS_CONDITIONS: 'store_terms_conditions',
  YOUR_BALANCE: 'store_your_balance',
};

export default STORE_TRANSLATION_KEYS;
